/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalizationPreference
 */
export interface LocalizationPreference {
    /**
     * 
     * @type {string}
     * @memberof LocalizationPreference
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the LocalizationPreference interface.
 */
export function instanceOfLocalizationPreference(value: object): value is LocalizationPreference {
    return true;
}

export function LocalizationPreferenceFromJSON(json: any): LocalizationPreference {
    return LocalizationPreferenceFromJSONTyped(json, false);
}

export function LocalizationPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalizationPreference {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function LocalizationPreferenceToJSON(value?: LocalizationPreference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
    };
}

